import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'app-internal-shell',
    imports: [RouterOutlet],
    templateUrl: './internal-shell.component.html',
    styleUrl: './internal-shell.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternalShellComponent {

}
